export default __webpack_public_path__ + "static/solucion_2-39eccae1fb5f12509d445734dce5ff71.jpg";